import React from "react";
import { BrandDetails } from "../../../../types/add-brand-types";
import SEOAnalysisCard from "../../../widgets/SeoAnalysysCard";
import "./seo.css";

interface SeoProps {
  brandDetails: BrandDetails;
  onSeoItemClick: (
    keyword: string,
    weeklyPlanItemId?: string,
    angle?: string
  ) => void;
  plannedTopic?: string | null;
  plannedItemId?: string | null;
  onConsumedPlannedTopic?: () => void;
}

const Seo: React.FC<SeoProps> = ({
  brandDetails,
  onSeoItemClick,
  plannedTopic,
  plannedItemId,
  onConsumedPlannedTopic,
}) => {
  return (
    <div className="growth-seo-container">
      {plannedTopic ? (
        <div className="growth-seo-planned-topic">
          <div>
            <span>Planned SEO draft</span>
            <strong>{plannedTopic}</strong>
          </div>
          <button
            type="button"
            onClick={() => {
              onSeoItemClick(
                plannedTopic,
                plannedItemId ?? undefined,
                "educational"
              );
              onConsumedPlannedTopic?.();
            }}
          >
            Generate article
          </button>
        </div>
      ) : null}
      <SEOAnalysisCard
        brandData={brandDetails}
        onSeoItemClick={onSeoItemClick}
      />
    </div>
  );
};

export default Seo;
